export default __webpack_public_path__ + "static/media/appLogo.0da412ff.png";